// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__xsxhA","messages":"Chat_messages__1z-CK","dateDivider":"Chat_dateDivider__1sPS7"};